/* -------------------------------------------------------------------------- */
/*                              Schema Routes                                 */
/* -------------------------------------------------------------------------- */

import { schema } from 'normalizr';

export const route = new schema.Entity('routes', {}, { idAttribute: 'routeId' });
export const routes = new schema.Array(route);
